import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ContactList from './../ContactList/index'
import style from './style';
import CloseIcon from '@mui/icons-material/Close';
import ContactList1 from './../ContactList1/index';
import ContactList2 from './../ContactList2/index';
import ContactList3 from './../ContactList3/index';
import { event } from 'react-ga';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
// }));

export default function SimpleTabs(props) {
  //const classes = useStyles();
  const classes = style();
  console.log(":::: ", props.sIndex);
  const [value, setValue] = React.useState(props.sIndex);
  const closePopUp = props.closePopUp;
  const dealId = props.dealId;
  const [tabs, setTabs] = useState([1,0,0]);

  const handleChange = (event, newValue) => {
    console.log(newValue);
    let tabs = [0,0,0];
    tabs[newValue] = 1;
    setTabs(tabs);
    console.log(tabs);
    setValue(newValue);
  };

  const closePopUpHandler = () => {
    closePopUp(false)
  };

  useEffect(() => {
      handleChange(event, props.sIndex);
  }, []);

  return (
    <div className={classes.tabsSection}>
      {/* <CloseIcon className={classes.topIconImage} style={{ fill: 'black' }} onClick={closePopUpHandler} /> */}
      <CloseIcon style={{ float: "right", fill: "black", position: "absolute", right: "2px", top: "32px", background: "lightgrey", fontSize: "26px", borderRadius: "50%", padding: "5px" }} onClick={closePopUpHandler} />
      <br/><br/>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange}  variant="scrollable" scrollButtons="auto" aria-label="simple tabs example">
          <Tab style={{background: tabs[0] ? "#53252f" : "white", color: tabs[0] ? "white" : "black"}} label="सभी" {...a11yProps(0)} />
          {/* <Tab style={{background: tabs[1] ? "#53252f" : "white", color: tabs[1] ? "white" : "black"}} label=" फ़ोन कॉल " {...a11yProps(1)} /> */}
          <Tab style={{background: tabs[1] ? "#53252f" : "white", color: tabs[1] ? "white" : "black"}} label=" दूसरे पक्ष की बोली " {...a11yProps(1)} />
          <Tab style={{background: tabs[2] ? "#53252f" : "white", color: tabs[2] ? "white" : "black"}} label="व्हाट्सप्प " {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <ContactList dealId={dealId}/>
      </TabPanel>
      {/* <TabPanel value={value} index={1}>
        <ContactList1 dealId={dealId}/>
      </TabPanel> */}
      <TabPanel value={value} index={1}>
        <ContactList3 dealId={dealId}/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ContactList2 dealId={dealId}/>
      </TabPanel>
    </div>
  );
}
